var _path, _path2, _path3, _path4, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 2.5H4.125C3.50368 2.5 3 2.92533 3 3.45V20.55C3 21.0747 3.50368 21.5 4.125 21.5H19.875C20.4963 21.5 21 21.0747 21 20.55V3.45C21 2.92533 20.4963 2.5 19.875 2.5Z",
    fill: "url(#paint0_linear_4143_7157)",
    stroke: "#19233C",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 8L17.9 8",
    stroke: "#19233C",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 16L17.9 16",
    stroke: "#19233C",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.49985L8 9.42842L11 6.42842",
    stroke: "#19233C",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 15.5996,
    r: 2,
    stroke: "#19233C",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4143_7157",
    x1: 7.09091,
    y1: 20.6364,
    x2: 18.9436,
    y2: 4.83273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestActive);
export default __webpack_public_path__ + "static/media/quest-active.b197e9b7a53a6a12edb747e10a7e2f12.svg";
export { ForwardRef as ReactComponent };